/**
 * Main entry point for the App view
 */
import { storeInit, store } from './stores';
import App from './components/App/App.svelte';

document.addEventListener('DOMContentLoaded', init);

/**
 * DOM dependent functionality should be initialised here.
 * Do not put code in here that does not depend on the DOM.
 */
function init() {
    // Get the mount point for the App
    const target = document.getElementById('Survey');

    // Optional: Grab a configuration rendered by the server and use it to generate a store.
    storeInit(window.Survey);

    // eslint-disable-next-line
    new App({ target });

    // For debug purposes you can add the store to the window object, this will make it easier to inspect during development.
    window.store = store;
}
